import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { REGISTRATION_CONFIG } from '@us-registration/util-models';

export const wibMatcher: CanMatchFn = () => {
  const config = inject(REGISTRATION_CONFIG);
  return Boolean(config.features.wibEnabled);
};
